import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/layout/images/logo-home.svg")